import { Component, EventEmitter, Input, Output } from "@angular/core";
import { LayoutAlignDirective, LayoutDirective } from "@ngbracket/ngx-layout/flex";
import { BidQuoteModel } from "../../interfaces";
import { BidQuoteComponent } from "./bidQuote.component";

@Component({
    selector: "bid-quotes",
    templateUrl: "./bidQuotes.tmpl.html",
    styleUrls: [
        "./bidQuotes.component.scss"
    ],
    imports: [
        BidQuoteComponent,
        LayoutAlignDirective,
        LayoutDirective,
    ]
})
export class BidQuotesComponent
{
    @Output() readonly delete = new EventEmitter<BidQuoteModel>();
    @Output() readonly viewAttachments = new EventEmitter<BidQuoteModel>();
    @Output() readonly viewNotes = new EventEmitter<BidQuoteModel>();

    @Input() canEdit: boolean;
    @Input() model: BidQuoteModel[];

    get bidQuotes(): BidQuoteModel[] { return this.model; }
    get hasBidQuotes(): boolean { return this.bidQuotes?.length > 0; }

    onDelete(selected: BidQuoteModel): void
    {
        this.delete.emit(selected);
    }

    showAttachments(selected: BidQuoteModel): void
    {
        this.viewAttachments.emit(selected);
    }

    showNotes(selected: BidQuoteModel): void
    {
        this.viewNotes.emit(selected);
    }
}
